



























































































































































































































































































































































import AppraisalResponseCard from "@/components/appraisal/AppraisalResponseCard.vue";
import ClearanceApprovalResponseCard from "@/components/clearance-approval/ClearanceApprovalResponseCard.vue";
import ClearanceResponseCard from "@/components/clearance-approval/ClearanceResponseCard.vue";
import CompanySheet from "@/components/company/CompanySheet.vue";
import SnapshotDetail from "@/components/handover/SnapshotDetail.vue";
import SnapshotSignResponseCard from "@/components/handover/SnapshotSignResponseCard.vue";
import ActivityTimeLineItemDocumentCard from "@/components/partner/ActivityTimeLineItemDocumentCard.vue";
import ActivityTimeLineItemSignedCard from "@/components/partner/ActivityTimeLineItemSignedCard.vue";
import PartnerReportMapAddress from "@/components/partner/report/v2/PartnerReportMapAddress.vue";
import PartnerReportRepairInfo from "@/components/partner/report/v2/repair/PartnerReportRepairInfo.vue";
import PartnerReportTowingCard from "@/components/partner/report/v2/towing/PartnerReportTowingCard.vue";
import ReportBaseTimeLine from "@/components/partner/ReportBaseTimeLine.vue";
import SharedContentAccessDescription from "@/components/partner/SharedContentAccessDescription.vue";
import SharedContentAccessExpired from "@/components/partner/SharedContentAccessExpired.vue";
import SharedContentVehicleCard from "@/components/partner/SharedContentVehicleCard.vue";
import SharedContentContactCard from "@/components/partner/SharedContentContactCard.vue";
import RentalResponseCard from "@/components/rental/RentalResponseCard.vue";
import RepairEstimateResponseCard from "@/components/repair-estimate/RepairEstimateResponseCard.vue";
import MSelect from "@/components/utility/mmmint/MSelect.vue";
import TimelineCard from "@/components/utility/TimelineItem.vue";
import Tooltip from "@/components/utility/tooltip.vue";
import LayoutReportFullWidth from "@/layouts/LayoutReportFullWidth.vue";
import { AttachmentRequestStatusEnum } from "@/lib/enum/attachment-request-status.enum";
import { DigitalSignatureRequestStatusEnum } from "@/lib/enum/digital-signature-request-status.enum";
import { RefDocumentType } from "@/lib/shared-content/RefDocument";
import { FetchStrategyRegistry, SharedContentFetchService } from "@/lib/shared-content/SharedContentFetchStrategy";
import {
  AttachmentRequestFetchStrategy,
  ClearanceApprovalFetchStrategy,
  ClearanceFetchStrategy,
  DocumentFetchStrategy,
  RentalFetchStrategy,
  RepairEstimateFetchStrategy,
  ReportFetchStrategy,
  SignFetchStrategy,
  SnapshotFetchStrategy
} from "@/lib/shared-content/strategies";
import { SnapshotSignResponseFetchStrategy } from "@/lib/shared-content/strategies/SnapshotSignResponseFetchStrategy";
import { AppraisalFetchStrategy } from "@/lib/shared-content/strategies/AppraisalFetchStrategy";
import { detailedDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { dottedSubString } from "@/lib/utility/string-helper";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { IReport, Report } from "@/models/report.entity";
import sharedContentService from "@/services/mrfiktiv/services/sharedContentService";
import {
  MrfiktivAttachmentResponseViewModelGen,
  MrfiktivReportViewModelGen,
  MrfiktivSharedContentViewmodelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { SignDigitalSignatureRequestSignerViewModelGen } from "@/services/sign/v1/data-contracts";
import { BackendResourceEnum, FrontendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { CoverageTypeEnum } from "@/store/enum/coverage-type.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import { VideoFetchStrategy } from "@/lib/shared-content/strategies/VideoFetchStrategy";

type SharedDocument = {
  refDocument: RefDocumentType;
  refType: string;
  refId: string;
};

@Component({
  components: {
    LayoutReportFullWidth,
    ReportBaseTimeLine,
    Tooltip,
    TimelineCard,
    SharedContentAccessDescription,
    SharedContentAccessExpired,
    ActivityTimeLineItemDocumentCard,
    SnapshotDetail,
    SnapshotSignResponseCard,
    RepairEstimateResponseCard,
    RentalResponseCard,
    ClearanceApprovalResponseCard,
    ClearanceResponseCard,
    AppraisalResponseCard,
    ActivityTimeLineItemSignedCard,
    PartnerReportRepairInfo,
    CompanySheet,
    PartnerReportTowingCard,
    PartnerReportMapAddress,
    MSelect,
    SharedContentVehicleCard,
    SharedContentContactCard,
    MTextField
  },
  filters: {
    detailedDate
  }
})
class SharedContentView extends Vue {
  readonly dottedSubString = dottedSubString;

  loading = false;

  isExpired = false;
  isThrottled = false;
  isNotFound = false;

  isExpand = true;

  sharedContent: MrfiktivSharedContentViewmodelGen | null = null;

  sharedDocuments: SharedDocument[] = [];

  get isCompleted() {
    return this.attachmentRequest?.status === AttachmentRequestStatusEnum.COMPLETED;
  }
  /**
   * Dont offer print option if we share anything but a report - only show print button for reports
   */
  get hidePrint() {
    const isReportSharing = this.sharedDocuments.find(d => d.refType === BackendResourceEnum.REPORT);

    return !isReportSharing;
  }

  get ResourceEnum() {
    return ResourceEnum;
  }

  get FrontendResourceEnum() {
    return FrontendResourceEnum;
  }

  get accessToken() {
    return this.$route.params.token;
  }

  get partner() {
    return ReportModule.partner;
  }

  get user() {
    return this.sharedContent?.user;
  }

  get companyName() {
    return this.partner.companyName;
  }

  get color() {
    return this.partner.settings?.color ?? "primary";
  }


  get coverageTypeItems() {
    return Object.values(CoverageTypeEnum).map(value => ({
      value,
      text: this.$t(`enums.CoverageTypeEnum.${value}`)
    }));
  }

  get attachmentRequest(): MrfiktivAttachmentResponseViewModelGen | undefined {
    return this.sharedDocuments?.find(
      sd =>
        sd.refType === ResourceEnum.ATTACHMENT_REQUEST &&
        (sd.refDocument as MrfiktivAttachmentResponseViewModelGen).status !== AttachmentRequestStatusEnum.COMPLETED
    )?.refDocument as MrfiktivAttachmentResponseViewModelGen;
  }

  get attachmentRequestId() {
    return this.sharedDocuments?.find(
      sd =>
        sd.refType === ResourceEnum.ATTACHMENT_REQUEST &&
        (sd.refDocument as MrfiktivAttachmentResponseViewModelGen).status !== AttachmentRequestStatusEnum.COMPLETED
    )?.refId;
  }

  get requests() {
    const checkList: { refId: string; refType: BackendResourceEnum; isDone: boolean }[] = [];
    this.sharedDocuments.forEach(r => {
      if (r.refType === ResourceEnum.REPAIR_ESTIMATE) {
        const isDone = (r.refDocument as IRepairEstimate).isCompleted;
        checkList.push({ refId: r.refId, refType: r.refType, isDone: isDone });
      }
    });
    return checkList;
  }

  get signRequests(): SignDigitalSignatureRequestSignerViewModelGen[] | undefined {
    return this.sharedDocuments
      ?.filter(sd => sd.refType === ResourceEnum.SIGN)
      .map(v => v.refDocument as SignDigitalSignatureRequestSignerViewModelGen)
      .filter(sr => sr.status !== DigitalSignatureRequestStatusEnum.SIGNED);
  }

  get report(): IReport | undefined {
    const report = this.sharedDocuments?.find(sd => sd.refType === ResourceEnum.REPORT)
      ?.refDocument as MrfiktivReportViewModelGen;

    if (!report) {
      return undefined;
    }

    return new Report(report);
  }

  get showSubmitData() {
    return this.attachmentRequest;
  }

  // Latest status entry derived from statusHistory
  get latestStatus() {
    const history = this.report?.statusHistory;
    if (!history || history.length === 0) {
      return undefined as any;
    }
    return history[history.length - 1];
  }

  // Remaining statuses excluding the latest, shown in reverse chronological order
  get remainingStatuses() {
    const history = this.report?.statusHistory;
    if (!history || history.length <= 1) {
      return [] as any[];
    }
    const withoutLatest = history.slice(0, history.length - 1);
    return withoutLatest.slice().reverse();
  }

  formatDetailedDate(date: Date): string {
    return detailedDate(date.getTime());
  }

  async mounted() {
    this.loading = true;
    this.isExpired = false;

    try {
      // Fetch shared content
      this.sharedContent = await sharedContentService.access(this.partner.id, this.accessToken);

      const registry = new FetchStrategyRegistry();

      registry.register(new ReportFetchStrategy());
      registry.register(new DocumentFetchStrategy());
      registry.register(new SnapshotFetchStrategy());
      registry.register(new RepairEstimateFetchStrategy());
      registry.register(new SignFetchStrategy());
      registry.register(new AttachmentRequestFetchStrategy());
      registry.register(new ClearanceApprovalFetchStrategy());
      registry.register(new ClearanceFetchStrategy());
      registry.register(new AppraisalFetchStrategy());
      registry.register(new RentalFetchStrategy());
      registry.register(new SnapshotSignResponseFetchStrategy());
      registry.register(new VideoFetchStrategy());

      const fetchService = new SharedContentFetchService(registry);
      const results = await fetchService.fetchContent(this.partner.id, this.sharedContent, this.accessToken);

      // Filter out null documents and preserve order
      this.sharedDocuments = results
        .filter(doc => doc.refDocument !== null)
        .map(result => ({
          refDocument: result.refDocument,
          refType: result.refType,
          refId: result.refId
        }));
    } catch (e) {
      if ((e as any).message === "Sharing document expired") {
        this.isExpired = true;
      } else if ((e as any).message === "ThrottlerException: Too Many Requests") {
        this.isThrottled = true;
      } else {
        handleError(e);
      }
    } finally {
      this.loading = false;
    }
  }

  print() {
    window.print();
  }

  startAttachmentRequest() {
    if (!this.attachmentRequestId) {
      return undefined;
    }

    this.$router.push({
      name: "ReportDataResponse",
      params: {
        accessToken: this.accessToken
      }
    });
  }

  startSignRequest(signRequestId: string) {
    this.$router.push({
      name: "DigitalSignature",
      params: {
        signRequestId
      }
    });
  }
}
export default SharedContentView;
